var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',_vm._b({staticClass:"kp-light-toolbar",attrs:{"color":"lightToolbar","elevation":"0"}},'v-toolbar',{ ..._vm.$attrs, ..._vm.$props },false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }